import useEnrolmentState from "./useEnrolmentState";
import {dateToInputString} from "../Utils/DataCollectionUtils";
import {useEffect} from "react";
import {debugLog} from "../Utils/LogUtils";

//Configures the enrolment state to have mock data for testing
export default function useMockEnrolmentState() {
    const enrolmentState = useEnrolmentState();


    useEffect(() => {
        //Only load the mock data if the environment variable is set.
        if (!process.env.REACT_APP_LOAD_MOCK_ENROLLMENT_DATA) {
            return;
        }


        enrolmentState.setApplication({
            ...enrolmentState.application,
            tcpName: 'John Doe',
            tcpRelationship: 'Parent',
            tcpPhone: '123-456-7890',
            tcpEmail: 'john.doe@gmail.com',
        });

        enrolmentState.setBeneficiary({
            ...enrolmentState.beneficiary,
            firstName: 'Jane',
            middleName: 'Mary',
            lastName: 'Doe',
            birthdate: dateToInputString(new Date())
        });

        enrolmentState.setSubscriber({
            ...enrolmentState.subscriber,
            firstName: 'John',
            middleName: 'Michael',
            email: 'n3v3rd13@hotmail.com',
            lastName: 'Doe',
            title: "Mr.",
            birthdate: dateToInputString(new Date(1990, 9, 20)),
        });

        enrolmentState.setPlan({
            ...enrolmentState.plan,
            type: 0,
        });

        enrolmentState.setCommon({
            ...enrolmentState.common,
            subscriber2Include: true,
        });

        enrolmentState.setJointSubscriber({
            ...enrolmentState.jointSubscriber,
            firstName: 'Jessica',
            middleName: 'Lindsay',
            lastName: 'Johnson',
            title: "Ms.",
        });


    }, []);

    return enrolmentState;
}